/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum OrganizationRawMaterialRequestChecklistItemStatus {
  NOT_STARTED = "not_started",
  REQUEST_SENT = "request_sent",
  NEEDS_REVIEW = "needs_review",
  NEEDS_ATTENTION = "needs_attention",
  FULFILLED = "fulfilled",
}
